import { callEndpoint } from '../backend';
import { get, remove } from '../local-storage';
import captureSpecificError from '../capture-error';
import { getStore } from '../store';
import {
  postMemberSettings,
  updateMemberSettings,
} from '../store/modules/app-controls';
import { persistMetaAttribution } from '../facebook';

const convertUnitsConfig = ({ unitsConfig, defaultUnitsConfig }) => ({
  measurementSystem:
    unitsConfig?.system?.options?.find((option) => option.active === true)
      ?.id ?? 'custom',
  coordinate:
    unitsConfig?.coordinate?.options?.find((option) => option.active === true)
      ?.id ?? defaultUnitsConfig.coordinate,
  distance:
    unitsConfig?.distance?.options?.find((option) => option.active === true)
      ?.id ?? defaultUnitsConfig.distance,
  speed:
    unitsConfig?.speed?.options?.find((option) => option.active === true)?.id ??
    defaultUnitsConfig.speed,
  swellHeight:
    unitsConfig?.swellHeight?.options?.find((option) => option.active === true)
      ?.id ?? defaultUnitsConfig.swellHeight,
  temperature:
    unitsConfig?.temperature?.options?.find((option) => option.active === true)
      ?.id ?? defaultUnitsConfig.temperature,
  tideHeight:
    unitsConfig?.tideHeight?.options?.find((option) => option.active === true)
      ?.id ?? defaultUnitsConfig.tideHeight,
  windSpeed:
    unitsConfig?.windSpeed?.options?.find((option) => option.active === true)
      ?.id ?? defaultUnitsConfig.windSpeed,
});

const convertWeatherConfig = ({ weatherConfig }) => ({
  weatherOnStartup: weatherConfig.weatherOnStartup,
  weatherOnMapCenter: weatherConfig.useMapCenter,
});

export const ensureMemberSettings = async () => {
  const member = getStore().getState().backendService.currentMember;

  if (!member) {
    return;
  }

  let memberSettings = null;
  try {
    memberSettings = await callEndpoint(
      callEndpoint.endpoints.getMemberSettings,
    );
  } catch (err) {
    captureSpecificError(
      err,
      'containers/app-main-client/src/services/user/ensureMemberSettings.js',
    );
  }

  if (memberSettings?.selectedSettings) {
    getStore().dispatch(updateMemberSettings(memberSettings.selectedSettings));
    // Refresh Meta attribution ids now that the member is known (post-login).
    void persistMetaAttribution();
    return;
  }

  const usersUnitsConfig = await get('userService', 'unitsConfig');
  const weatherSettings = await get('weather', 'settings');
  const tripsConfig = await get('userService', 'tripsConfig');

  const defaultMemberSettings =
    getStore().getState().appControls.memberSettings;

  const newMemberSettings = {
    ...defaultMemberSettings,
  };

  if (usersUnitsConfig) {
    newMemberSettings.unitsConfig = convertUnitsConfig({
      unitsConfig: usersUnitsConfig,
      defaultUnitsConfig: defaultMemberSettings.unitsConfig,
    });
  }
  if (tripsConfig) newMemberSettings.tripsConfig = tripsConfig;
  if (weatherSettings) {
    newMemberSettings.weatherConfig = convertWeatherConfig({
      weatherConfig: weatherSettings.weatherConfig,
    });
  }

  try {
    await getStore().dispatch(postMemberSettings(newMemberSettings)).unwrap();

    remove('userService', 'unitsConfig');
    remove('weather', 'settings');
    remove('userService', 'tripsConfig');

    void persistMetaAttribution();
  } catch (err) {
    captureSpecificError(
      err,
      'containers/app-main-client/src/services/user/ensureMemberSettings.js',
    );
  }
};
